import React from "react"
import { Routes, Route, Navigate, useLocation } from "react-router-dom"
import Layout from "../components/Layout"
import Login from "../pages/Login"
import Dashboard from "../pages/Dashboard"
import Users from "../pages/users/Users"
import CreateUser from "../pages/users/CreateUsers"
import EditUser from "../pages/users/EditUsers"
import Sensors from "../pages/sensors/Sensor"
import CreateSensor from "../pages/sensors/CreateSensors"
import EditSensor from "../pages/sensors/EditSensor"
import CCTV from "../pages/CCTV"
import AISMonitoring from "../pages/AISMonitoring"
import { useAuth } from "../context/AuthContext"
import Roles from "../pages/roles/Roles"
import CreateRole from "../pages/roles/CreateRole"
import EditRole from "../pages/roles/EditRole"
import SensorTypeList from "../pages/sensorTypes/SensorTypeList"
import CreateSensorType from "../pages/sensorTypes/CreateSensorType"
import EditSensorType from "../pages/sensorTypes/EditSensorType"
import { hasRouteAccess } from "../utils/permissions"
import ClientRegistration from "../pages/administration/ClientRegistration"
import VesselLists from "../pages/vessel/VesselLists"
import ClientManagement from "../pages/administration/ClientManagement"

function PrivateRoute({ children }) {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check if user has permission to access the current route
  if (!hasRouteAccess(user.permissions, location.pathname)) {
    return <Navigate to="/" replace />
  }

  return children
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/create" element={<CreateUser />} />
        <Route path="users/edit/:id" element={<EditUser />} />
        <Route path="sensors" element={<Sensors />} />
        <Route path="sensors/create" element={<CreateSensor />} />
        <Route path="sensors/edit/:id" element={<EditSensor />} />
        <Route path="cctv" element={<CCTV />} />
        <Route path="ais-monitoring" element={<AISMonitoring />} />
        <Route path="roles" element={<Roles />} />
        <Route path="roles/create" element={<CreateRole />} />
        <Route path="roles/edit/:id" element={<EditRole />} />
        <Route path="sensor-types" element={<SensorTypeList />} />
        <Route path="sensor-types/create" element={<CreateSensorType />} />
        <Route path="sensor-types/edit/:id" element={<EditSensorType />} />
        <Route 
          path="client-registration" 
          element={<ClientRegistration />}
        />
        <Route path="client-management" element={<ClientManagement />} />
        <Route path="vessel-lists" element={<VesselLists />} />
      </Route>
    </Routes>
  )
}
